import { AdLayout } from './shared/components/AdLayout'

// The /labs suite landing: a short "what is this" line and a list of the labs games.
// One game today (24); the GAMES array is the seam for adding rebus / cryptic / … later.
const GAMES = [
  {
    slug: '24',
    title: 'The 24 Game',
    blurb: 'Make 24 from four numbers using + − × ÷. Think out loud as you solve.',
  },
]

export const Landing = () => {
  // Path-agnostic link base (works at /labs, /labs/, or a different mount) — links back
  // to the same directory + the game slug, e.g. /labs/24.
  const base = typeof window !== 'undefined' ? window.location.pathname.replace(/\/+$/, '') : ''

  return (
    <AdLayout>
      <div className="flex flex-col items-center px-6 pt-12 pb-10 text-center">
        <div className="select-none leading-none">
          <span className="nerdle-name text-3xl font-extrabold">nerdle</span>{' '}
          <span className="nerdle-sub-name text-3xl font-semibold text-gray-400">labs</span>
        </div>

        <p className="mt-6 max-w-md leading-relaxed text-gray-600">
          This is where we trial new, experimental puzzle games and study how people solve lateral
          thinking puzzles. All labs games are voice activated so we can track how you think! Our
          first game is the “24” number puzzle. More games coming soon!
        </p>

        <div className="mt-8 w-full max-w-md space-y-3">
          {GAMES.map((g) => (
            <a
              key={g.slug}
              href={`${base}/${g.slug}`}
              className="block rounded-xl border border-gray-200 p-4 text-left transition-colors hover:border-[#820458] hover:bg-[#820458]/5"
            >
              <div className="text-lg font-semibold text-gray-800">{g.title}</div>
              <div className="mt-1 text-sm text-gray-500">{g.blurb}</div>
            </a>
          ))}
        </div>

        <p className="mt-10 max-w-md text-xs leading-relaxed text-gray-400">
          If you’re interested in supporting our research, or have any comments or questions, please
          email{' '}
          <a href="mailto:contact@nerdlegame.com" className="underline hover:text-[#820458]">
            contact@nerdlegame.com
          </a>
          .
        </p>
        <p className="mt-3 text-xs text-gray-400">
          <a href={`${base}/privacy.html`} className="underline hover:text-[#820458]">
            Privacy policy
          </a>
        </p>
      </div>
    </AdLayout>
  )
}
